import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { OfferRoutingModule } from './offers.routing.module';

import { OfferService } from './services/offer.service';
import { OfferListPageComponent } from './containers/offer-list-page/offer-list-page.component';
import { OfferPreviewPageComponent } from './containers/offer-preview-page/offer-preview-page.component';
import { OfferMetricsPageComponent } from './containers/offer-metrics-page/offer-metrics-page.component';
import { OfferFormRecipientsComponent } from './components/offer-form-recipients/offer-form-recipients.component';
import { OfferCopytoclipboardComponent } from './components/offer-copytoclipboard/offer-copytoclipboard.component';
import { OfferTableComponent } from './components/offer-table/offer-table.component';
import { StrategyService } from '../strategies/services/strategy.service';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    OfferRoutingModule
  ],
  declarations: [
    OfferPreviewPageComponent,
    OfferCopytoclipboardComponent,
    OfferListPageComponent,
    OfferFormRecipientsComponent,
    OfferMetricsPageComponent,
    OfferTableComponent
  ],
  providers: [
    OfferService,
    StrategyService
  ]
})
export class OffersModule { }
